import {useCallback,useEffect,useRef,useState} from "react";
import {useAuth} from "@/contexts/AuthContext";
/** Only an opening or the row's explicit recovery writes. A GET reread cannot. */
export function useReadMarks({items,selected,write,reread}:{
  items?:Array<{id:string;unread:boolean}>;selected?:string;write(id:string):Promise<unknown>;reread():void;
}) {
  const {me}=useAuth();
  const actor=`${me?.tenant_id}/${me?.user_id}`;
  const current=useRef(items);current.current=items;
  const refresh=useRef(reread);refresh.current=reread;
  const tried=useRef(new Set<string>());
  const [states,setStates]=useState<Record<string,{failed:boolean;pending:boolean}>>({});
  const open=useCallback((id:string,retry=false)=>{
    const key=`${actor}/${id}`;
    if((tried.current.has(key)&&!retry)||!current.current?.find(row=>row.id===id)?.unread)return;
    tried.current.add(key);
    setStates(was=>({...was,[key]:{failed:false,pending:true}}));
    void write(id).then(()=>{
      setStates(was=>({...was,[key]:{failed:false,pending:false}}));refresh.current();
    }).catch(()=>setStates(was=>({...was,[key]:{failed:true,pending:false}})));
  },[actor,write]);
  const available=Boolean(items);
  useEffect(()=>{if(selected&&available)open(selected);},[selected,available,open]);
  return {open,close:(id:string)=>tried.current.delete(`${actor}/${id}`),
    mark:(id:string)=>({...states[`${actor}/${id}`]??{failed:false,pending:false},retry:()=>open(id,true)})};
}
